import { render, staticRenderFns } from "./get-link.vue?vue&type=template&id=10c396bb"
import script from "./get-link.vue?vue&type=script&lang=js"
export * from "./get-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports